import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Grid, Loader } from 'semantic-ui-react';

import { Card, List } from '../..';
import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';

import { NotificationsMainPropsGeneric } from './types';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import analytics from '../../../shared/services/analytics/analytics';
import { useCallback } from 'react';

const NotificationsMain = ({ isFetching, data, getLastNotifications, handleMakeItScroll, intl }: NotificationsMainPropsGeneric) => {
  const handleSeeAllClick = useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_notification_see_all');
  }, []);

  const handleRefreshClick = useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_notification_refresh');
    getLastNotifications();
  }, [getLastNotifications]);

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        title={intl.formatMessage({
          id: 'dashboardMain.dashboardUpperRow.notifications',
          defaultMessage: localeData.en['dashboardMain.dashboardUpperRow.notifications'],
        })}
        headerLink="/messages/notifications"
        headerLinkLabel={intl.formatMessage({
          id: 'dashboardMain.dashboardUpperRow.seeAll',
          defaultMessage: localeData.en['dashboardMain.dashboardUpperRow.seeAll'],
        })}
        onHeaderLinkClick={handleSeeAllClick}
      >
        {isFetching ? (
          <div className="'dashboard__loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <List
            title={intl.formatMessage({
              id: 'dashboardMain.dashboardUpperRow.mostRecent',
              defaultMessage: localeData.en['dashboardMain.dashboardUpperRow.mostRecent'],
            })}
          >
            <div>
              {data && data.size > 0 ? (
                <ul className="list__items">
                  {data.map((notification: any, index: number) => {
                    const onClick = () => handleMakeItScroll(notification.get('id'), 'dashboard-notifications');

                    return (
                      <li
                        key={`${notification.get('id')}-${index}`}
                        className={addModifiers('list__item', notification.get('read') === false ? ['bullet-highlight'] : [])}
                      >
                        <Link to={'/messages/notifications'} onClick={onClick}>
                          {notification.get('title') !== '' && notification.get('title') !== null
                            ? `${notification.get('title')}`
                            : `Notification ${index + 1}`}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <div>
                  <FormattedMessageHelper
                    tagName="span"
                    id="dashboardMain.notifications.no.results"
                    defaultMessage={localeData.en['dashboardMain.notifications.no.results']}
                  />
                  <div className="button-refresh__content">
                    <button className="button button--refresh" onClick={handleRefreshClick} />
                  </div>
                </div>
              )}
            </div>
          </List>
        )}
      </Card>
    </Grid.Column>
  );
};

export default injectIntl(NotificationsMain);
